CustomTC.define('modules/util',['modules/core', 'modules/constants', 'modules/logger'], function(core, constants, logger) {
    return {
        // format timestamp to readable text
        timeAgo: function(timestamp) {
            var units = [{
                    name: "s",
                    limit: 60,
                    in_seconds: 1
                }, //second
                {
                    name: "m",
                    limit: 3600,
                    in_seconds: 60
                }, //minute
                {
                    name: "h",
                    limit: 86400,
                    in_seconds: 3600
                }, //hour
                {
                    name: "d",
                    limit: 604800,
                    in_seconds: 86400
                }, //day
                {
                    name: "w",
                    limit: 2629743,
                    in_seconds: 604800
                }, //week
                {
                    name: "mo",
                    limit: 31556926,
                    in_seconds: 2629743
                }, //month
                {
                    name: "y",
                    limit: null,
                    in_seconds: 31556926
                } //year
            ];
            var diff = (new Date() - new Date(timestamp * 1000)) / 1000;
            if (diff < 5) return "now";
            var i = 0,
                unit;
            while (unit = units[i++]) {
                if (diff < unit.limit || !unit.limit) {
                    var diff = Math.floor(diff / unit.in_seconds);
                    return diff + " " + unit.name + (diff > 1 ? "" : "");
                }
            };
        },
        // format time  
        formatTime: function(time, hours) {
            if (hours) {
                var h = Math.floor(time / 3600);
                time = time - h * 3600;
                var m = Math.floor(time / 60);
                var s = Math.floor(time % 60);
                return this.leadZero(h, 2) + ":" + this.leadZero(m, 2) + ":" + this.leadZero(s, 2);
            } else {
                var m = Math.floor(time / 60);
                var s = Math.floor(time % 60);
                return this.leadZero(m, 2) + ":" + this.leadZero(s, 2);
            }
        },
        // lead zero
        leadZero: function(num, n) {
            var nz = "" + num;
            while (nz.length < n) {
                nz = "0" + nz;
            }
            return nz;
        },
        // read cookie
        readCookie: function(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        // write cookie
        writeCookie: function(name, value, seconds) {
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/";
        },
        // get domain
        getDomain: function(url) {
            var domain = url.toLowerCase(); //we are only interested in domain 
            if (domain.match(/^https?:\/\//))
                domain = domain.replace(/^https?:\/\//, '');
            return domain.replace(/\/.*$/g, ''); //extract only domain
        },
        // get browser
        getBrowser: function() {
            var N = navigator.appName,
                ua = navigator.userAgent,
                tem;
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*(\.?\d+(\.\d+)*)/i);
            if (M && (tem = ua.match(/version\/([\.\d]+)/i)) !== null) {
                M[2] = tem[1];
            }
            M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
            return M[0];
        },
        // check if supports webm
        supportsWebm: function() {
            if (!this.supportsVideo())
                return false;
            return this.videoChecker.canPlayType('video/webm; codecs="vp8, vorbis"') === 'probably';
        },
        // check if opera
        isOpera: function() {
            return !!window.opera || navigator.userAgent.indexOf('Opera') >= 0;
        },
        // check if firefox
        isFirefoxa: function() {
            return typeof InstallTrigger !== 'undefined';
        },
        // check if safari
        isSafari: function() {
            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('CriOS') === -1) {
                return true;
            } else {
                return false;
            }
        },
        // check if chrome
        isChrome: function() {
            return !!window.chrome;
        },
        isiPad: function() {
            return navigator.userAgent.match(/iPad/i) !== null;
        },
        isiPhone: function() {
            return navigator.userAgent.match(/iPhone/i) !== null;
        },
        isiPod: function() {
            return navigator.userAgent.match(/iPod/i) !== null;
        },
        isAndroid: function() {
            return navigator.userAgent.match(/Android/i) !== null;
        },
        isTouchDevice: function() {
            return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
        },
        ieVersion: function() {
            //Set defaults
            var value = {
                IsIE: false,
                TrueVersion: 0,
                ActingVersion: 0,
                CompatibilityMode: false
            };

            //Try to find the Trident version number
            var trident = navigator.userAgent.match(/Trident\/(\d+)/);
            if (trident) {
                value.IsIE = true;
                //Convert from the Trident version number to the IE version number
                value.TrueVersion = parseInt(trident[1], 10) + 4;
            }

            //Try to find the MSIE number
            var msie = navigator.userAgent.match(/MSIE (\d+)/);
            if (msie) {
                value.IsIE = true;
                //Find the IE version number from the user agent string
                value.ActingVersion = parseInt(msie[1]);
            } else {
                //Must be IE 11 in "edge" mode
                value.ActingVersion = value.TrueVersion;
            }

            //If we have both a Trident and MSIE version number, see if they're different
            if (value.IsIE && value.TrueVersion > 0 && value.ActingVersion > 0) {
                //In compatibility mode if the trident number doesn't match up with the MSIE number
                value.CompatibilityMode = value.TrueVersion !== value.ActingVersion;
            }
            return value;
        },
        // get ie version
        getIEVersion: function() {
            if (window.navigator.userAgent.indexOf("Edge") > -1) {
                return 'Edge';
            } else {
                var ieVal = this.ieVersion();
                if (ieVal.IsIE === false) {
                    return undefined
                } else {
                    return ieVal.TrueVersion;
                }
                //var match = navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
                //return match ? parseInt(match[1]) : undefined;
            }
        },
        // get ff version
        getFFVersion: function() {
            var ver = navigator.userAgent.replace(/.*?Firefox\/(.*?)\..*/g, '$1');
            return isNaN(ver) ? undefined : ver;
        },
        // get safari version
        getSafariVersion: function() {
            var verOffset = navigator.userAgent.indexOf("Safari");
            var fullVersion = navigator.userAgent.substring(verOffset + 7);
            if ((verOffset = navigator.userAgent.indexOf("Version")) !== -1)
                fullVersion = navigator.userAgent.substring(verOffset + 8);
            if ((ix = fullVersion.indexOf(";")) !== -1) fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) !== -1) fullVersion = fullVersion.substring(0, ix);
            var majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }


            return majorVersion;
        },
        // see if firefox supports mp4
        getFFSupport: function() {
            if (this.getFFVersion() < 35 || (!this.supportsH264Main() && !this.supportsMP4()))
                return false;
            return true;
        },
        // check if html5 playabe
        html5Playable: function(hasWebmVideo) {
            if (this.isSafari() || this.isChrome() || this.getIEVersion() > 9) {
                return true;
            } else if (hasWebmVideo !== undefined && this.supportsWebm()) {
                playerMode = 'html5';
                return true;
            } else if (this.getFFSupport() && this.getIEVersion() === undefined) {
                return true;
            } else {
                return false;
            }
        },
        // get flash object
        getFlashMovieObject: function(movieName) {
            if (window.document[movieName]) {
                return window.document[movieName];
            }
            if (navigator.appName.indexOf("Microsoft Internet") !== -1) {
                return window[movieName];
            } else {
                return document.getElementById(movieName);
            }
        },
        // find pos
        findPos: function(obj) {
            var curleft = 0,
                curtop = 0;
            if (obj.offsetParent) {
                do {
                    curleft += obj.offsetLeft;
                    curtop += obj.offsetTop;
                } while (obj = obj.offsetParent);
                return {
                    x: curleft,
                    y: curtop
                };
            }
            return undefined;
        },
        // get click position
        getClickPos: function(e, self, elem, useClientRect, useEle) {
            var pos = this.findPos(self);
            var x, y = 0;

            if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
                var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                x = touch.pageX - elem.offset().left;
                y = touch.pageY - elem.offset().top;
            } else if (this.isiPhone() || this.isiPod() || this.isiPad()) {
                x = e.pageX;
                y = e.pageY;
            } else if (this.getBrowser() === 'Trident' || this.getIEVersion() !== undefined || useEle === 1) {
                x = e.pageX - elem.offset().left;
                y = e.pageY - elem.offset().top;
            } else {
                x = e.pageX - pos.x;
                y = e.pageY - pos.y;
            }
            var xClick = x / elem.width();
            var yClick = y / elem.height();
            logger.log('X Percentage from Player - ', xClick);
            logger.log('Y Percentage from Player - ', yClick);
            logger.log('X from Player - ', x);
            logger.log('Y from Player - ', y);
            return {
                'xClick': xClick,
                'yClick': yClick
            };
        },
        // get touch event
        getTouchEvent: function(e) {
            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            return {
                pageX: touch.pageX,
                pageY: touch.pageY,
                originalEvent: {
                    touches: [{
                        pageX: touch.pageX,
                        pageY: touch.pageY
                    }]
                }
            };
        },
        getBinaryValue: function(r, g, b, reversed) {
            var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
            if (reversed && reversed === 'yes') {
                return (yiq >= 128) ? '1' : '0';
            } else {
                return (yiq >= 128) ? '0' : '1';
            }
        },
        padZero: function(num, size) {
            var s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        },
        isHighDensity: function() {
            return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
        },
        escapeHTML: function(string) {
            var entityMap = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': '&quot;',
                "'": '&#39;',
            };
            return String(string).replace(/[&<>"']/g, function(s) {
                return entityMap[s];
            });
        },
        linkify: function(string) {
            var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            //var urlRegex = /(https?:\/\/[^\s]+)/g;
            return string.replace(urlRegex, function(url, b, c) {
                var url2 = (c === 'www.') ? 'http://' + url : url;
                return '<a href="javascript:TouchCast.InteractiveLayer.openPipMode(\'' + url2 + '\');" target="_blank">' + url2 + '</a>';
            });
            /*// http://, https://, ftp://
            var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

            // www. sans http:// or https://
            var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

            // Email addresses
            var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

            return string
                .replace(urlPattern, '<a href="javascript:TouchCast.InteractiveLayer.openPipMode(\'$&\');"><img id="demo" src="' + config.domain + '/sdk/screenshot/index.php?url=$&">$&</a>');
            //.replace(pseudoUrlPattern, '$1<a href="http://$2">$2</a>')
            //.replace(emailAddressPattern, '<a href="mailto:$&">$&</a>');*/
        },
        // check if we are able play video inline on iphone/ipod
        checkIfInlinePlaySupported: function() {
            if (this.isSafari()) {
                if ((/iphone|ipod/gi).test(navigator.platform)) {
                    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                    var version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                    logger.log('iOS version - ', version);
                    if (version[0] >= 10) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
            return false;
        },
        // check if we are able play video inline on iphone/ipod
        checkIfLiveInteractivitySafariSupported: function() {
            if (this.isSafari()) {
                if ((this.isiPad() || this.isiPhone() || this.isiPod())) {
                    return false;
                } else if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
                    var userAgent = navigator.userAgent.toLowerCase();
                    var v = userAgent.match(/os x (\d+)_(\d+)_?(\d+)?/);
                    if (v && v !== null) {
                        var version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                        //logger.log('Mac OS version - ', version);
                        if (version[0] < 10) {
                            return false;
                        } else if (version[1] < 12) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            } else {
                return true;
            }
            return true;
        },
        hexToRgba: function(hex, opacity) {
            hex = hex.replace('#', '');
            r = parseInt(hex.substring(0, 2), 16);
            g = parseInt(hex.substring(2, 4), 16);
            b = parseInt(hex.substring(4, 6), 16);

            result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
            return result;
        },
        getDevicePixelRatio:function () {
            var ratio = 1;
            // To account for zoom, change to use deviceXDPI instead of systemXDPI
            if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
                // Only allow for values > 1
                ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
            } else if (window.devicePixelRatio !== undefined) {
                ratio = window.devicePixelRatio;
            }
            return ratio;
        }
    };
});
